import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { useParams } from "next/navigation";
interface PostPrevNextNavProps {
  prev?: { id: number; title: string };
  next?: { id: number; title: string };
}

export default function PostPrevNextNav({ prev, next }: PostPrevNextNavProps) {
  const params = useParams<{ slug: string }>();
  const slug = params?.slug || "";

  if (!prev && !next) return null;

  return (
    <ul className="border-midGray-30 border-t-[2px] border-b-[2px] my-20">
      {next && (
        <li>
          <Link
            href={`/app/${slug}/${next.id}`}
            className="flex items-center px-3 py-5 hover:bg-gray-50 transition-colors duration-200"
          >
            <div className="flex items-center min-w-20 text-softGray-70">
              <span className="mr-2 medium-text-16">다음</span>
              <FontAwesomeIcon icon={faChevronUp} size="sm" />
            </div>
            <p className="regular-text-18 text-black-almostBlack ml-3 line-clamp-1">
              {next.title}
            </p>
          </Link>
        </li>
      )}

      {prev && (
        <li className="border-b border-softGray-10">
          <Link
            href={`/app/${slug}/${prev.id}`}
            className="flex items-center px-3 py-5 hover:bg-gray-50 transition-colors duration-200"
          >
            <div className="flex items-center min-w-20 text-softGray-70">
              <span className="mr-2 medium-text-16">이전</span>
              <FontAwesomeIcon icon={faChevronDown} size="sm" />
            </div>
            <p className="regular-text-18 text-black-almostBlack ml-3 line-clamp-1">
              {prev.title}
            </p>
          </Link>
        </li>
      )}
    </ul>
  );
}
